<div id="pu-floating-button__shell" #shellContainer>
  <floating-button
    [actions]="actions"
    [blockBotButton]="blockBotButton"
    (popupOpened)="onPopupOpen($event)"
  ></floating-button>
</div>

<ng-template
  #welcomeTemplate
  let-click="click"
  let-close="close"
>
  <div class="pu-floating-button__welcome">
    <div class="pu-floating-button__welcome-head">
      <div class="pu-floating-button__welcome-header pu-floating-button__welcome-bold">{{ 'tourGuide.welcome.header' | translateIn }}</div>
      <button
        class="pu-floating-button__welcome-close pu-floating-button__welcome-close__pad-0"
        type="button"
        puButton
        size="m"
        uiType="quaternary"
        [onlyIcon]="true"
        (click)="close()">
        <pu-icon iconName="close" size="14" />
      </button>
    </div>

    <div class="pu-floating-button__welcome-row">{{ 'tourGuide.welcome.message' | translateIn }}</div>

    <div class="pu-floating-button__welcome-row pu-floating-button__welcome-bold">{{ 'tourGuide.welcome.try' | translateIn }}</div>

    <div class="pu-floating-button__welcome-buttons">
      <button
        type="button"
        puButton
        uiType="quaternary"
        size="s"
        translate="tourGuide.welcome.clickButton"
        (click)="click()"
      ></button>
    </div>
  </div>
</ng-template>

<ng-template
  #openHrBotTemplate
  let-click="click"
  let-close="close"
>
  <div class="pu-floating-button__open-bot">
    <div class="pu-floating-button__open-bot-head">
      <div class="pu-floating-button__open-bot-header pu-floating-button__open-bot-bold">{{ 'tourGuide.openBot.header' | translateIn }}</div>
      <button
        class="pu-floating-button__open-bot-close"
        type="button"
        puButton
        size="m"
        uiType="quaternary"
        [onlyIcon]="true"
        (click)="close()">
        <pu-icon iconName="close" size="10" />
      </button>
    </div>

    <div class="pu-floating-button__open-bot-row">
      {{ 'tourGuide.openBot.message.simply' | translateIn }}
      <span class="pu-floating-button__open-bot-bold">{{ 'tourGuide.openBot.message.click' | translateIn }}</span>
      {{ 'tourGuide.openBot.message.start' | translateIn }}
    </div>

    <div class="pu-floating-button__open-bot-buttons">
      <button
        type="button"
        puButton
        uiType="quaternary"
        size="s"
        translate="tourGuide.openBot.clickButton"
        (click)="click()"
      ></button>
    </div>
  </div>
</ng-template>
